import { StoreState } from '@/redux/types';

export const getDesignFavorites = (state: StoreState) => state.designs.favorites;
